"use strict";

module.exports =
{
	// Output
	ABSOLUTE:      "absolute",
	PATH_RELATIVE: "pathRelative",
	ROOT_RELATIVE: "rootRelative",
	SHORTEST:      "shortest"
};



//////////////////
// WEBPACK FOOTER
// ./~/relateurl/lib/constants.js
// module id = 1762
// module chunks = 0